<template>
  <b-card>
    <div
      class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
    >
      <h3 class="mt-1">
        <feather-icon
          icon="BriefcaseIcon"
          class="mr-50"
          style="width: 18px; height: 18px"
        />
        <span>Sponsors</span>
      </h3>
      <div class="d-flex">
        <!-- <b-button class="mt-1 mr-50" @click="removeSponsors">
          <feather-icon icon="Trash2Icon" />
          <span> Delete </span>
        </b-button> -->
        <b-button class="gradient-btn mt-1" :to="{ name: 'sponsors-create' }">
          <feather-icon icon="PlusIcon" />
          <span> Create </span></b-button
        >
      </div>
    </div>
    <b-form
      @submit.prevent="filter"
      class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
    >
      <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
        <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
        <v-select
          :options="types"
          v-model="type"
          label="label"
          :reduce="(option) => option.value"
          :searchable="false"
          placeholder="Display on the page"
          class="w-100"
        ></v-select>
      </div>

      <div class="col-sm-6 col-12 d-flex align-items-center p-50">
        <b-form-input
          placeholder="search"
          v-model.trim="search"
          :disabled="!type"
        />
      </div>
      <div class="col-sm-3 col-12 p-50">
        <b-button class="w-100" type="submit" :disabled="!search">
          <span class="text-muted h5"> Filtering</span>
        </b-button>
      </div>
    </b-form>
    <data-table :fields="fields" :items="sponsors" :loading="loading">
      <template #selectsponsors="{ data }">
        <div class="d-flex">
          <div class="pr-50 border-right mr-75">
            <!-- <b-form-checkbox
              v-model="removeSponsorsData"
              :value="data.item.id"
            ></b-form-checkbox> -->
            <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
          </div>
        </div>
      </template>
      <template #name="{ data }">
        <span style="white-space: nowrap">
          <b-avatar
            size="40"
            variant="light-primary"
            rounded="avatar"
            style="border: 2px solid #73747e !important"
            :src="data.item.logo"
          />
          {{ data.item.name || "-" }}
        </span>
      </template>

      <template #active="{ data }">
        <b-badge
          class="p-75"
          :variant="data.item.active ? 'light-success' : 'light-danger'"
        >
          {{ data.item.active ? "Active" : "Not active" }}
        </b-badge>
      </template>
      <template #special="{ data }">
        <span class="text-muted">
          {{ data.item.special }}
        </span>
      </template>
      <!-- <template class="nowrap-white-space" #support_amount="{ data }">
        <span class="text-white text-lighten-3">
          ${{ String(data.item.support_amount) || "-" }}
        </span>
      </template> -->

      <template #business_scale="{ data }">
        {{ String(data.item.business_scale) || "-" }}
      </template>
      <template #audience="{ data }"> {{ data.item.audience }} </template>
      <template #actions="{ data }">
        <div class="nowrap-white-space">
          <b-dropdown no-caret class="d-flex d-xl-none more-option">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" />
            </template>
            <b-dropdown-item
              variant="flat-primary"
              :to="{
                name: 'sponsors-edit',
                params: {
                  id: data.item.id,
                },
              }"
            >
              <div class="d-flex align-items-center w-100">
                <feather-icon icon="EditIcon" class="mr-50" />Edit
              </div>
            </b-dropdown-item>
          </b-dropdown>
          <div class="d-xl-flex d-none">
            <b-button
              variant="flat-primary"
              class="mx-25"
              :to="{
                name: 'sponsors-edit',
                params: {
                  id: data.item.id,
                },
              }"
              ><feather-icon icon="EditIcon" />Edit</b-button
            >
            <!-- <b-button
            class="mx-25"
            variant="flat-danger"
            @click="removeSponsor(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">Delete</span>
          </b-button> -->
          </div>
        </div>
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-between"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        class="my-2 d-flex justify-content-center"
      >
      </b-pagination>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BDropdown,
  BDropdownItem,
  BAvatar,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VSelect from "vue-select";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    VSelect,
    BDropdown,
    BDropdownItem,
    BAvatar,
  },
  data() {
    return {
      selectAll: false,
      removeSponsorsData: [],
      url: "/panel/sponsors",
      pages: [],
      selectedPage: "",
      currentPage: 1,
      loading: false,
      pagination: {},
      types: [
        { label: "Name", value: "name" },
        // { label: "Business scale", value: "business_scale" },
        // { label: "Support amount", value: "support_amount" },
        // { label: "Audience", value: "audience" },
      ],
      type: "",
      search: "",
      fields: [
        { key: "selectsponsors", label: "row" },
        { key: "name", label: "name" },
        { key: "active", label: "active" },
        { key: "special", label: "special" },
        // { key: "support_amount", label: "support amount" },
        { key: "business_scale", label: "business scale" },
        { key: "audience", label: "audience" },
        { key: "actions", label: "operation" },
      ],
      sponsors: [],
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (this.$route.fullPath != "/sponsors") {
        this.$router.push({
          name: "sponsors",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "sponsors",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.removeSponsorsData = [];
        this.getSponsors();
      },
      immediate: true,
      deep: true,
    },
    selectAll: {
      handler(val) {
        val
          ? (this.removeSponsorsData = this.sponsors.map(
              (sponsor) => sponsor.id
            ))
          : (this.removeSponsorsData = []);
      },
      immediate: true,
    },
    removeSponsorsData: {
      handler(val) {
        val.length == this.sponsors.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "sponsors",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "sponsors",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        filter[this.type] = this.search;
        this.$router.push({
          name: "sponsors",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/sponsors") {
        this.$router.push({
          name: "sponsors",
        });
      }
    },
    removeSponsor(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about deleting this option ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/sponsors/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeSponsorsData = [];
                await this.getSponsors();
              } else {
                await this.$router.push({
                  name: "sponsors",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your option has been deleted successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeSponsors() {
      if (this.removeSponsorsData.length) {
        this.$bvModal
          .msgBoxConfirm("Are you sure about deleting these options ?", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.removeSponsorsData.map(
                  async (faq) =>
                    await this.$http.delete(`/panel/sponsors/${faq}`)
                );
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeSponsorsData = [];
                  await this.getSponsors();
                } else {
                  await this.$router.push({
                    name: "sponsors",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Your options have been deleted successfully.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "There is some problem",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "No option selected ",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getSponsors() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.sponsors = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
